// SectionLayoutSettings.jsx
import React from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Stack } from '@mui/material';
import HelpTooltip from '../../../components/HelpTooltip';

const SectionLayoutSettings = ({ sectionId, sections, setSections }) => {
  const currentLayout = sections[sectionId]?.layout || { mode: 'default', width: '100%', align: 'left' };

  const updateLayout = (field, value) => {
    setSections(prev => ({
      ...prev,
      [sectionId]: {
        ...prev[sectionId],
        layout: {
          ...(prev[sectionId]?.layout || { mode: 'default', width: '100%', align: 'left' }),
          [field]: value,
        },
      },
    }));
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 600 }}>Layout Settings</Typography>
      <Stack direction="row" spacing={2} flexWrap="wrap">
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Layout Mode</InputLabel>
          <Select value={currentLayout.mode || 'default'} onChange={e => updateLayout('mode', e.target.value)}>
            <MenuItem value="default">Default (Full Table)</MenuItem>
            <MenuItem value="simple">Simple (Compact Checklist)</MenuItem>
            <MenuItem value="pricing">Pricing Table</MenuItem>
            <MenuItem value="four-wheel">Four-Wheel Input</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 160 }}>
          <InputLabel>Width</InputLabel>
          <Select value={currentLayout.width || '100%'} onChange={e => updateLayout('width', e.target.value)}>
            <MenuItem value="100%">100% (Full Width)</MenuItem>
            <MenuItem value="50%">50% (Two Columns)</MenuItem>
            <MenuItem value="33.33%">33.33% (Three Columns)</MenuItem>
            <MenuItem value="25%">25% (Four Columns)</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>Alignment</InputLabel>
          <Select value={currentLayout.align || 'left'} onChange={e => updateLayout('align', e.target.value)}>
            <MenuItem value="left">Left</MenuItem>
            <MenuItem value="center">Center</MenuItem>
            <MenuItem value="right">Right</MenuItem>
          </Select>
        </FormControl>
      </Stack>
    </Box>
  );
};

export default SectionLayoutSettings;